import { ContentState, convertToRaw } from "draft-js";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import PlainEditor from "../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import executeRequest from "../../../modules/request.js";
import LoadingComponent from "../../../shared/ui/animations/loading.js";
import Button from "../../../shared/ui/inputs/classicButton.js";
import "../../../../../shared/styles/colorDefinitions.css";
import "../../../style.css";
import { updateStyle } from "../gallery/scripts/useStyle.js";
import "./index.css";
function Container() {
    const [infoAfterPayment, setInfoAfterPayment] = useState("");
    const [summaryUrl, setSummaryUrl] = useState(undefined);
    useEffect(() => {
        executeRequest("/api/public/users/gallery/getGroupContent", "GET", {}).then((response) => {
            if (response.status === 404)
                return setInfoAfterPayment(JSON.stringify(convertToRaw(ContentState.createFromText("Użytkownik nie jest zalogowany na żadne zamówienie"))));
            setInfoAfterPayment(response.content.infoAfterPayment);
            const newUrl = `/order.html?orderId=${response.orderId}&key=${response.key}`;
            setSummaryUrl(newUrl);
            localStorage.setItem(response.orderId, newUrl);
            updateStyle(response.style, response.design);
        });
    }, []);
    return (React.createElement("div", { className: "main-container" },
        React.createElement("main", { className: "main-box" },
            infoAfterPayment ?
                React.createElement(PlainEditor, { onChange: () => { }, label: "", example: infoAfterPayment, editable: false })
                : React.createElement(LoadingComponent, { color: "classic" }),
            summaryUrl && (React.createElement(Button, { text: "", value: "show-order-summary", onClick: () => {
                    if (!summaryUrl)
                        return;
                    window.open(summaryUrl, "_self");
                } }, "Zobacz podsumowanie zam\u00F3wienia")))));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
